module.exports = __webpack_public_path__ + "img/STERiJECT_s2.fbfb5e75.png";